// 50_000 value was chosen based on popular model limits
export const PROMPT_MAX_CHARS = 50_000;
export const PROMPT_CONCAT_MAX_CHARS = 1_000;
export const LIST_MAX_CHARS = 10_000;
